import { combineEpics } from 'redux-observable';
import { filter, map, mergeMap } from 'rxjs/operators';
import { isActionOf } from 'typesafe-actions';

import { downloadProductImages, downloadProductImagesFailure, downloadProductImagesSuccess } from '../ducks/documents';
import { productImagesLongPolling } from '../logic/productImages';
import { downloadURI } from '../services/download';
import { isDefined } from '../utils/is';

const downloadProductImagesEpic: AppEpic = (action$, _, { documentsRepository }) => {
  return action$.pipe(
    filter(isActionOf(downloadProductImages)),
    map(action => action.payload),
    mergeMap(async payload => documentsRepository.downloadProductImages(payload)),
    mergeMap(res => productImagesLongPolling(res.data.link as string)),
    map(link => {
      if (isDefined(link)) {
        downloadURI(link, 'productImages');

        return downloadProductImagesSuccess();
      }

      return downloadProductImagesFailure();
    }),
  );
};

export const documentsEpic = combineEpics(downloadProductImagesEpic);
